export const PartnersSection = {
  title: 'Socis',
  description:
    `Assolim el lideratge cooperant només amb socis fiables i de provada reputació. Totes les nostres ofertes es basen en l'alta qualitat i la professionalitat per oferir als clients només el millor del món de la innovació. Perquè pugui encendre la tetera amb un xàfec de dits i la temperatura de la pròpia casa s'ajusti a les seves preferències. Estem segurs que només una cooperació honesta i mútuament beneficiosa amb els socis li permetrà viure en una casa d'oci que cuida de vostè.`,
};
